import { render, staticRenderFns } from "./CreateContactModal.vue?vue&type=template&id=3206841c&scoped=true&"
import script from "./CreateContactModal.vue?vue&type=script&lang=js&"
export * from "./CreateContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3206841c",
  null
  
)

export default component.exports